<template>
  <div class="homePage">
    <!-- 头部轮播图 -->
    <div class="topSwiper">
      <el-carousel height="100vh" class="spBox" :interval="5000" arrow="always">
        <el-carousel-item v-for="(item, index) in topBanner" :key="index">
          <img class="spImg" :src="item.url" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div class="moreButton" @click="goMore(5)">了 解 更 多</div>
    </div>
    <!-- 移动端-头部轮播图 -->
    <div class="topSwiper2">
      <el-carousel height="100vh" class="spBox" :interval="5000" arrow="always">
        <el-carousel-item v-for="(item, index) in topBanner2" :key="index">
          <img class="spImg" :src="item.url" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div class="moreButton" @click="goMore(5)">了 解 更 多</div>
    </div>
    <div class="homeBoxA">
      <div class="homeBoxAContent">
        <div class="haLeft">
          <div v-if="secondIndex == 0" class="halItem">
            <div class="halItem1 fade-enter-active">价值观 VALUE</div>
            <div class="halItem2 fade-enter-active">成就客户，持续创新<br />共享成长，诚信负责</div>
          </div>
          <div v-if="secondIndex == 1" class="halItem">
            <div class="halItem1 fade-enter-active">愿景 VISION</div>
            <div class="halItem2 fade-enter-active">
              成为工业物联硬件细分领域品牌领跑者，<br />数字化制造领域实践专家
            </div>
          </div>
          <div v-if="secondIndex == 2" class="halItem">
            <div class="halItem1 fade-enter-active">使命 MISSION</div>
            <div class="halItem2 fade-enter-active">
              让数智化成为每个港口加速度
            </div>
          </div>
        </div>
        <div class="secondDots">
          <div class="sdot" :class="secondIndex == 0 ? 'sdotActSty' : ''"></div>
          <div class="sdot" :class="secondIndex == 1 ? 'sdotActSty' : ''"></div>
          <div class="sdot" :class="secondIndex == 2 ? 'sdotActSty' : ''"></div>
        </div>
        <div class="haRight">
          <el-carousel
            @change="swiper2Change"
            :indicator-position="'none'"
            height="650px"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              v-for="(item2, index2) in secondBanner"
              :key="index2"
            >
              <img class="hasItem" :src="item2.url" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="haRight2">
          <el-carousel
            @change="swiper2Change"
            :indicator-position="'none'"
            height="350px"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              v-for="(item2, index2) in secondBanner"
              :key="index2"
            >
              <img class="hasItem" :src="item2.url" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="homeBoxB">
      <img
        class="hbBg"
        src="http://cdn.xiyundata.com/crane_index/version3/v3index04.png"
        alt=""
      />
      <img
        class="hbBg2"
        src="http://cdn.xiyundata.com/crane_index/version3/v3index04.png"
        alt=""
      />
      <div class="homeBoxBInner">
        <div style="width: 420px;">
          <div class="hbLine3">用心打造工业物联硬件</div>
          <div class="hbDesc">
            为您提供易用的，好用的，品质过硬的高性价比的工业物联硬件产品
          </div>
          <div class="hbLink-btn">
            <div @click="goMore(3)" class="text">查看详情</div>
          </div>
        </div>
      </div>
      <img class="numBg" src="http://cdn.xiyundata.com/crane_index/version3/v3index07.png" alt="">
    </div>
    <div class="homeBoxB" style="background-color: #33333A;">
      <img
        class="hbBg"
        src="http://cdn.xiyundata.com/crane_index/version3/v3index05.png"
        alt=""
      />
      <img
        class="hbBg2"
        src="http://cdn.xiyundata.com/crane_index/version3/v3index05.png"
        alt=""
      />
      <div class="homeBoxBInner" style="background-color: #33333A;">
        <div style="width: 420px;">
          <div class="hbLine3" style="color: #FFFFFF;">接替人</div>
          <div class="hbDesc" style="color: #FFFFFF;">
            用运力串联起各个生产和生活要素<br />并覆盖运营与运转
          </div>
          <div class="hbLink-btn" style="border: 1px solid #FFFFFF;">
            <div @click="goMore(3)" class="text" style="color: #FFFFFF;">查看详情</div>
          </div>
        </div>
      </div>
      <img class="numBg" src="http://cdn.xiyundata.com/crane_index/version3/v3index08.png" alt="">
    </div>
    <div class="homeBoxB">
      <img
        class="hbBg"
        src="http://cdn.xiyundata.com/crane_index/version3/v3index06.png"
        alt=""
      />
      <img
        class="hbBg2"
        src="http://cdn.xiyundata.com/crane_index/version3/v3index06.png"
        alt=""
      />
      <div class="homeBoxBInner">
        <div style="width: 420px;">
          <div class="hbLine3">互联人</div>
          <div class="hbDesc">从需求分析到方案落地的数字化解决方案</div>
          <div class="hbLink-btn">
            <div @click="goMore(3)" class="text">查看详情</div>
          </div>
        </div>
      </div>
      <img class="numBg" src="http://cdn.xiyundata.com/crane_index/version3/v3index09.png" alt="">
    </div>
  </div>
</template>

<script >
export default {
  data() {
    return {
      activeNum: 1,
      activeNum2: 1,
      topBanner: [
        {
          id: 1,
          url: "http://cdn.xiyundata.com/crane_index/version3/v3index01.png",
        },
        {
          id: 2,
          url: "http://cdn.xiyundata.com/crane_index/version3/v3index02.png",
        },
        {
          id: 3,
          url: "http://cdn.xiyundata.com/crane_index/version3/v3index03.png",
        },
      ],
      topBanner2: [
        {
          id: 1,
          url: "http://cdn.xiyundata.com/crane_index/version3/v3index01m1.png",
        },
        {
          id: 2,
          url: "http://cdn.xiyundata.com/crane_index/version3/v3index02m2.png",
        },
        {
          id: 3,
          url: "http://cdn.xiyundata.com/crane_index/version3/v3index03m3.png",
        },
      ],
      secondBanner: [
        {
          id: 1,
          url: "http://cdn.xiyundata.com/crane_index/home04.jpg",
        },
        {
          id: 2,
          url: "http://cdn.xiyundata.com/crane_index/home05.jpg",
        },
        {
          id: 3,
          url: "http://cdn.xiyundata.com/crane_index/home06.jpg",
        },
      ],
      secondIndex: 0,
    };
  },
  methods: {
    swiper2Change(e) {
      this.secondIndex = e;
    },
    goMore(index) {
      this.$emit("go-to-page", index);
    },
    // 处理滚动的方法
    // handleScroll(event) {
    //   // 阻止默认的滚动行为
    //   event.preventDefault();

    //   // 计算滚动方向和距离
    //   var delta = event.deltaY;
    //   var scrollDirection = delta > 0 ? 1 : -1;
    //   var scrollAmount = window.innerHeight; // 每次滚动的距离为视口的高度

    //   // 滚动到下一个视口高度的位置
    //   window.scrollTo({
    //     top: window.pageYOffset + scrollAmount * scrollDirection,
    //     behavior: 'smooth'
    //   });
    // }
  },
  mounted() {
    // 组件挂载后添加滚动事件监听器
    // window.addEventListener('wheel', this.handleScroll, { passive: false });
  },
  beforeUnmount() {
    // 组件卸载前移除滚动事件监听器
    // window.removeEventListener('wheel', this.handleScroll, { passive: false });
  }
};
</script>

<style scoped>
.topSwiper {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.topSwiper .moreButton {
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: absolute;
  bottom: 90px;
  transform: translateX(-50%);
  left: 50%;
  border-color: #fff;
  color: #fff;
  background: hsla(0, 0%, 100%, 0.1);
  border: 1px solid #fff;
  border-radius: 5rem;
  cursor: pointer;
  width: 178px;
  height: 55px;
  font-size: 19px;
}
.moreButton:hover {
  background: linear-gradient(to right, #09addb, #0ebab0);
  border: 1px solid transparent;
}
.spBox {
  width: 100%;
}
.spImg {
  width: 100%;
  vertical-align: middle;
}
.homePage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #F5F5F7;
}
.homeBoxA {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: #F5F5F7;
}
/* 定义淡入动画的类 */
.fade-enter-active {
  animation: fadeIn 0.5s ease-in-out;
}

.halItem1 {
  color: #33333A;
  font-size: 30px;
  margin-bottom: 48px;
  transition: opacity 0.5s ease-in-out;
}
.halItem2 {
  height: 400px;
  /* background-image: -webkit-linear-gradient(180deg, #29f19c, #02a1f9); */
  font-weight: 400;
  font-size: 20px;
  color: #66666A;
  -webkit-background-clip: text;
  background-clip: text;
  /* color: transparent; */
  /* font-size: 36px;
  font-weight: bold; */
  letter-spacing: 2px; /* 增加字间距 */
  line-height: 1.5;
  transition: opacity 0.5s ease-in-out; /* 定义透明度的过渡效果 */
}

.homeBoxAContent {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 1000px;
  height: 100%;
  background: #F5F5F7;
}
.haLeft {
  padding-top: 220px;
  padding-left: 30px;
  width: 477px;
}
.secondDots {
  position: absolute;
  bottom: 70px;
  left: 0;
  display: flex;
}
.sdot {
  height: 5px;
  border-bottom: 1px solid #cccccc;
  margin: 0 4px;
  width: 80px;
  transition: background-color 0.2s;
}
.sdotActSty {
  height: 5px;
  border-bottom: none;
  /* background-image: -webkit-linear-gradient(180deg, #29f19c, #02a1f9); */
  background: linear-gradient( 90deg, rgba(218,0,16,0) 0%, #DA0010 100%);
}
.haRight {
  width: 468px;
  height: 800px;
  padding-top: 88px;
}
.haRight2 {
  width: 100%;
  height: 277px;
  padding-top: 40px;
}
.hasItem {
  width: 468px;
}

.homeBoxB {
  overflow: hidden;
  position: relative;
  /* background-image: url("https://www.westwell-lab.com/img/index/page3.jpg"); */
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #fff;
}
.numBg {
  width: 240px;
  height: auto;
  position: absolute;
  right: 50px;
  bottom: 40px;
}
.hbBg {
  /* position: absolute; */
  z-index: 0;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  /* -webkit-animation: brath 15s linear infinite;
  animation: brath 15s linear infinite;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center; */
}
.hbBg2 {
  /* position: absolute; */
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 72%;
  /* -webkit-animation: brath 15s linear infinite;
  animation: brath 15s linear infinite;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center; */
}
.homeBoxBInner {
  /* position: relative; */
  width: 993px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hbLine1 {
  font-size: 56px;
  color: #fff;
  font-weight: bold;
}
.hbLine2 {
  font-size: 52px;
  color: #fff;
  margin-top: 8px;
}
.hbLine3 {
  font-size: 30px;
  margin-top: 45px;
  font-weight: 700;
  color: #33333A;
}
.hbDesc {
  color: #33333A;
  font-size: 14px;
  margin-top: 16px;
  line-height: 1.5;
  font-weight: 400;
}
.hbLink-btn {
  cursor: pointer;
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #33333A;
  font-size: 18px;
  width: 179px;
  height: 50px;
  border: 1px solid #33333A;
}
.hbLink-btn .icon {
  background-color: #fff;
  border-radius: 4px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 19px;
  width: 30px;
  color: #0fbda9;
  font-size: 22px;
}
.hbLink-btn .text {
  font-size: 19px;
}
.hbLink-btn .text:hover {
  color: #DA0010;
}

/* 移动端适配 */
.topSwiper2 {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.topSwiper2 .moreButton {
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: absolute;
  bottom: 90px;
  transform: translateX(-50%);
  left: 50%;
  border-color: #fff;
  color: #fff;
  background: hsla(0, 0%, 100%, 0.1);
  border: 1px solid #fff;
  border-radius: 5rem;
  cursor: pointer;
  width: 178px;
  height: 33px;
  font-size: 14px;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes brath {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@media (max-width: 830px) {
  /* 隐藏原轮播图 */
  .topSwiper {
    display: none;
  }
  .homeBoxA {
    height: 90vh;
  }
  .homeBoxAContent {
    display: block;
    height: 100%;
  }
  .halItem1 {
    font-size: 30px;
    color: #DA0010;
  }
  .halItem2 {
    /* font-size: 24px; */
    height: 160px;
    font-weight: 400;
    font-size: 18px;
  }
  .haLeft {
    width: 100%;
    padding-top: 0px;
  }
  .sdot {
    width: 64px;
    height: 6px;
  }
  .haRight {
    display: none;
  }
  .haRight2 {
    display: block;
    padding-top: 10px;
  }
  .hbBg1 {
    display: none;
  }
  .hbBg2 {
    display: block;
  }
  .hbLine1 {
    font-size: 40px;
  }
  .hbLine2 {
    font-size: 32px;
  }
  .hbLine3 {
    font-size: 24px;
  }
  .hbDesc {
    font-size: 12px;
  }
  .homeBoxBInner {
    width: 85%;
    margin-left: 30px;
  }
  .homeBoxB {
    display: block;
  }
  .numBg {
    width: 104px;
    right: 18px;
    bottom: 22px;
  }
  .hbBg {
    display: none;
  }
  .hbLink-btn {
    width: 140px;
    height: 40px;
  }
  .hbLink-btn .text {
    font-size: 16px;
  }
}
@media (min-width: 830px) {
  /* 隐藏原轮播图 */
  .topSwiper2 {
    display: none;
  }
  .haRight {
    display: block;
  }
  .haRight2 {
    display: none;
  }
  .hbBg1 {
    display: block;
  }
  .hbBg2 {
    display: none;
  }
}
</style>

